import React from 'react';
import withClickOutsideOnOverlay from '../../../../../hoc/withClickOutsideOnOverlay';
import ConfirmPopup from '../../../../components/ConfirmPopup/ConfirmPopup';

function ChangesToPullForm({ onClose }) {
    return <ConfirmPopup
        onClose={onClose}
        okBtnLabel="Ok"
        okBtnCb={() => {
            onClose();
        }}
        hideCancelBtn={true}
        title="Attention"
        message="There are changes in the remote repository. Please pull them before pushing your changes to GitHub" />;
}

export default withClickOutsideOnOverlay(ChangesToPullForm);